import ComponentsConfig from "./components.config.js";

export default function(Vue) {
  for (let comp of ComponentsConfig["components"]) {
    if (comp.is_enabled) {
      // console.log("Registering component----->"+comp.component_name);
      Vue.component(comp.component_name, comp.component_property);
    }
  }
}
